<template>
  <base-modal>
    <z-form-group class="row form-group form-group--modal">
      <div class="col-11">
        <v-text-field
          :value="item.key" disabled="disabled"
          :label="$t('projects.sources.modal.api.key')"
          hide-details="auto"
          outlined
          dense
          height="30"
        />
      </div>
      <div class="col-1 pl-0">
        <table-control type="copy_2" @click="copy" />
      </div>
    </z-form-group>
    <p class="mt-4">
      Используйте этот ключ для добавления задач в проект через данный источник. Подробнее можно прочитать в
      <a href="https://harvest-expert-767.notion.site/enotCRM-v1-0-REST-API-ae55a99c151f4979a55b80a11b65f795" target="_blank">документации</a>
    </p>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';

  export default {
    components: { BaseModal },

    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    },

    methods: {
      copy() {
        navigator.clipboard.writeText(this.item.key);
      }
    }
  }
</script>

<style lang="scss">
  // .btn-copy {   // TO DO возможно удалить этот стиль, не нужен
    // padding-top: 19px;
  // }
  .btn-wrapper {
    display: flex;
    width: 100%;
    justify-content: flex-end;

    .ivu-btn {
      max-width: 150px;
    }
  }
</style>
